module.exports = __webpack_public_path__ + "static/media/hyundai-checkmark.27526ac2.svg";